import React, { useState, useEffect } from 'react'
import { Panel } from 'rsuite'
import { useForm } from 'react-hook-form'
import InnovationFrom from './InnovationFrom'
import notification from '../../utils/notification'
import { DELETE_SUCCESS_MSG, SAVE_SUCCESS_MSG } from '../../constants/msgText'
import { doneLoading, startLoading } from '../../utils/loading'
import {
  callIntellectualProperty,
  deleteIntellectualPropertyAttacthment,
  downIntellectualPropertyAttacthment,
  saveIntellectualProperty,
} from '../../redux/actions/intellectualProperty'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import { downloadFile, previewFile } from '../../utils/fileUtil'
import InnovationView from './InnovationView'

export default function InnovationWidgets(props) {
  const [formSchema, setFormSchema] = useState(props.schema)
  const [formValues, setFormValues] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const [deleteFileIds, setDeleteFileIds] = useState([])
  const [isOnSuccess, setIsOnSuccess] = useState(false)

  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    // console.log('formSchema 2 => ', formSchema?.values?.length)

    // setFormSchema(props.schema)

    const countValues = formSchema?.values?.length || 0

    let newArr = []
    if (countValues > 0) {
      console.log('> 0')
      setFormValues(formSchema?.values)

      formSchema?.values.map((item) => {
        // console.log('item => ', item)
        newArr.push(item.creator)
      })
    } else {
      console.log('< 0')
      setFormValues(null)
      newArr.push('')
    }

    // setCreatorValue(newArr)
  }, [])

  // useEffect(() => {
  //   handleReLoadData()
  // }, [])

  const onSubmitData = (data) => {
    console.log('onSubmit => ', data)

    let benefitArr = []
    if (data.benefitAcademic) {
      benefitArr.push(data.benefitAcademicDetail)
    }

    if (data.benefitPolicy) {
      benefitArr.push(data.benefitPolicyDetail)
    }

    if (data.benefitPublic) {
      benefitArr.push(data.benefitPublicDetail)
    }

    if (data.benefitCommerce) {
      benefitArr.push(data.benefitCommerceDetail)
    }

    // return false
    const formData = new FormData()

    formData.append('Id', data?.id || '')
    formData.append('ProgressId', data?.progressId || '')
    formData.append('Name', data?.name || '')
    formData.append('Detail', data?.detail || '')
    formData.append('InnovationType', data?.innovationType || '')
    formData.append('OtherInnovationType', data?.otherInnovationType || '')

    data.issue &&
      data.issue?.forEach((element) => {
        formData.append('Issue', element)
      })
    formData.append('OtherIssue', data?.otherIssue || '')

    data.target &&
      data.target?.forEach((element) => {
        formData.append('Target', element)
      })
    formData.append('OtherTarget', data?.otherTarget || '')

    formData.append('YearOfDevelopment', data?.yearOfDevelopment || '')

    data.attachFiles &&
      data.attachFiles?.forEach((element) => {
        formData.append('AttachFiles', element.blobFile)
      })

    data.creator &&
      data.creator?.forEach((element) => {
        formData.append('Creator', element)
      })

    // data.deleteFileIds &&
    //   data.deleteFileIds?.forEach((element) => {
    //     formData.append('DeleteFileIds', element)
    //   })
    const benefitJoinStr = benefitArr.length > 0 ? benefitArr.join() : ''
    // formData.append('Utilization', data?.utilization || '')
    formData.append('Utilization', '')
    // formData.append('UtilizationDetail', data?.utilizationDetail || '')
    formData.append('UtilizationDetail', benefitJoinStr)
    formData.append('TrlLevel', data?.trlLevel || '')
    formData.append('SlrLevel', data?.slrLevel || '')
    formData.append('DetailMore', data?.detailMore || '')
    // formData.append('BenefitAcademic', data?.detailMore || '')

    formData.append('FullName', data?.fullName || '')
    formData.append('Email', data?.email || '')
    formData.append('Telephone', data?.telephone || '')
    formData.append('Agency', data?.agency || '')
    formData.append('BenefitAcademic', data?.benefitAcademic || false)
    formData.append('BenefitAcademicDetail', data?.benefitAcademicDetail || '')
    formData.append('BenefitPolicy', data?.benefitPolicy || false)
    formData.append('BenefitPolicyDetail', data?.benefitPolicyDetail || '')
    formData.append('BenefitPublic', data?.benefitPublic || false)
    formData.append('BenefitPublicDetail', data?.benefitPublicDetail || '')
    formData.append('BenefitCommerce', data?.benefitCommerce || false)
    formData.append('BenefitCommerceDetail', data?.benefitCommerceDetail || '')

    formData.append('Criteria1', data?.criteria1 ? parseInt(data?.criteria1) : 0)
    formData.append('Criteria2', data?.criteria2 ? parseInt(data?.criteria2) : 0)
    formData.append('Criteria3', data?.criteria3 ? parseInt(data?.criteria3) : 0)

    handleSaveIntellectualProperty(formData, data?.id)
  }

  const handleSaveIntellectualProperty = async (request, id) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)

    try {
      let response = await saveIntellectualProperty(request, projectId)
      console.log('resssss => ', response)

      if (response) {
        setIsOnSuccess(true)

        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
        })

        handleReLoadData()

        !id && location.reload()
      }
    } catch (error) {
      console.log('error', error)
    }

    setTimeout(() => setIsOnSuccess(false), 1000)
    setIsLoading(false)
    doneLoading()
  }

  const handlePreviewFile = async (fileObj) => {
    console.log('file => ', fileObj)
    // return false
    startLoading()
    setIsLoading(true)
    try {
      var file = await downIntellectualPropertyAttacthment(fileObj?.id)
      var fileName = fileObj?.name || fileObj?.id

      previewFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'แสดง ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleDownloadFile = async (fileObj) => {
    setIsLoading(true)
    startLoading()
    try {
      var file = await downIntellectualPropertyAttacthment(fileObj.id)
      var fileName = fileObj.label

      downloadFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'ดาวน์โหลด ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleDeleteFile = async (fileObj, innovationId) => {
    // console.log('innovationId => ', innovationId)
    // console.log('handleDeleteFile => ', fileObj)
    // return false
    startLoading()
    setIsLoading(true)
    setIsError(false)

    try {
      // let newArr = []
      // newArr.push(fileObj.id)
      // setDeleteFileIds(newArr)
      let response = await deleteIntellectualPropertyAttacthment(
        projectId,
        innovationId,
        fileObj.id,
        '1'
      )
      console.log('resssss => ', response)
      notification.open('success', {
        title: DELETE_SUCCESS_MSG,
      })
      setIsOnSuccess(true)
      setFormValues(response.form.innovation.values)
    } catch (error) {
      console.log('error', error)
    }

    setTimeout(() => setIsOnSuccess(false), 1000)
    setIsLoading(false)
    doneLoading()
  }

  const handleReLoadData = async () => {
    setIsLoading(true)
    startLoading()

    try {
      const _schema = await callIntellectualProperty(projectId)
      // console.log('handleGetSchema => ', _schema.form?.innovation)
      // setSchema(_schema)
      // setFormSchema(_schema.form.innovation)
      // console.log('reload...')
      setFormValues(_schema.form.innovation.values)
      // console.log('end reload...')
    } catch (error) {
      console.log('error => ', error)
    }

    doneLoading()
    setIsLoading(false)
  }

  return (
    <>
      {isLoading && <OverlayLoader />}

      {formValues?.length > 0 && (
        <Panel
          shaded
          collapsible
          defaultExpanded
          header={formSchema?.header || ''}
          bordered
          style={{ marginBottom: 10 }}
        >
          {formValues.map((item, index) => {
            // console.log('ite m => ', item)
            if (item.disabled) {
              return (
                <>
                  <InnovationView
                    schema={formSchema}
                    index={index}
                    itemValue={item}
                    onSubmit={onSubmitData}
                    onPreview={handlePreviewFile}
                    onDownload={handleDownloadFile}
                    // onDelete={handleDeleteFile}
                    isSuccess={isOnSuccess}
                  />
                </>
              )
            } else {
              return (
                <>
                  <InnovationFrom
                    schema={formSchema}
                    index={index}
                    itemValue={item}
                    onSubmit={onSubmitData}
                    onPreview={handlePreviewFile}
                    onDownload={handleDownloadFile}
                    onDelete={handleDeleteFile}
                    isSuccess={isOnSuccess}
                  />
                </>
              )
            }
          })}
        </Panel>
      )}
    </>
  )
}
